import { Highlighting } from '@aipb/gulliver/castor/model';

export const DEFAULT_HIGHLIGHTING_PARAMS: Highlighting = {
  tagPre: '||',
  tagPost: '/||',
  fragsize: 100
};

export const ROUTE_CATEGORY_DETAIL = 'detail',
  ROUTE_CATEGORY_COMPARE = 'compare',
  ROUTE_CATEGORY_TOPIC = 'topic';
